var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGamepad = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#gamepad_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.25 5.969a.469.469 0 1 1-.938 0 .469.469 0 0 1 .938 0m0 2.187a.469.469 0 1 1-.938 0 .469.469 0 0 1 .938 0m-1.562-1.562a.469.469 0 1 1 0 .937.469.469 0 0 1 0-.937m2.187 0a.469.469 0 1 1 0 .937.469.469 0 0 1 0-.937"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.781 7.063a.5.5 0 0 0 .5.5h1.875a.5.5 0 1 0 0-1H3.281a.5.5 0 0 0-.5.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.219 8.5a.5.5 0 0 0 .5-.5V6.125a.5.5 0 0 0-1 0V8a.5.5 0 0 0 .5.5m2.812-1.437a.5.5 0 0 0 .5.5h.938a.5.5 0 0 0 0-1H7.53a.5.5 0 0 0-.5.5m2.595 2.781a.438.438 0 1 1 0-.875.438.438 0 0 1 0 .875m-1.437-.438a1.438 1.438 0 1 0 2.875 0 1.438 1.438 0 0 0-2.876 0m-3.249 0a1.438 1.438 0 1 0 2.875 0 1.438 1.438 0 0 0-2.875 0m1.437.438a.438.438 0 1 1 0-.875.438.438 0 0 1 0 .875",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.8 9.25a.5.5 0 0 0 .5.5h1.4a.5.5 0 0 0 0-1H7.3a.5.5 0 0 0-.5.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m.969 12.084.482-5.292v-.001a2.782 2.782 0 0 1 4.84-1.583.5.5 0 0 0 .373.167h2.672a.5.5 0 0 0 .372-.167 2.781 2.781 0 0 1 4.84 1.582l.001.002.482 5.292a1.375 1.375 0 0 1-2.483.792l-2.108-2.92a.5.5 0 0 0-.81.586l2.108 2.921.003.003a2.375 2.375 0 0 0 4.288-1.449L15.545 6.7v-.003a3.781 3.781 0 0 0-6.423-2.321H6.878a3.782 3.782 0 0 0-6.423 2.32V6.7l-.484 5.318-.002.046a2.375 2.375 0 0 0 4.29 1.403l.003-.003 2.108-2.92a.5.5 0 0 0-.81-.586l-2.108 2.919a1.375 1.375 0 0 1-2.483-.792",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.781 4.281a.5.5 0 0 0 .5-.5V3a.5.5 0 1 0-1 0v.781a.5.5 0 0 0 .5.5m-7.562 0a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-1 0v.781a.5.5 0 0 0 .5.5",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gamepad_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgGamepad;